// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'abastecimento.title': 'Abastecimentos',
    'abastecimento.aba.abastecimentos': 'Abastecimentos',
    'abastecimento.aba.solicitacoes': 'Solicitação de abastecimento',
    'abastecimento.protheus.hint': 'Lançados no Protheus, a partir de 01/09/2026.',
    'abastecimento.protheus.empty': 'Nenhum abastecimento no período.',
    'abastecimento.protheus.count': '{{count}} abastecimentos',
    'abastecimento.protheus.litros': '{{litros}} litros',
    'abastecimento.protheus.matricula': 'Matrícula {{matricula}}',
    'abastecimento.protheus.col.modalidade': 'Modalidade',
    'abastecimento.protheus.col.kmRodado': 'Km rodado',
    'abastecimento.protheus.col.kmL': 'Km/L',
    'abastecimento.protheus.tipo': 'Tipo de abastecimento',
    'abastecimento.protheus.interno': 'Interno',
    'abastecimento.protheus.externo': 'Externo',
    'abastecimento.protheus.internoHint': 'Postos Transgrãos e Valorem',
    'abastecimento.protheus.externoHint': 'Demais postos',
    'abastecimento.protheus.mediaGeral': 'Média geral',
    'abastecimento.protheus.kmHint': 'Soma dos intervalos válidos, sem Arla',
    'abastecimento.protheus.mediaHint': 'Km dividido por litros, sem Arla',
    'abastecimento.protheus.precoMedio': 'Preço médio do litro',
    'abastecimento.protheus.combustivel.S10': 'S10',
    'abastecimento.protheus.combustivel.S500': 'S500',
    'abastecimento.protheus.combustivel.Arla': 'Arla',
    'abastecimento.protheus.combustivel.Etanol': 'Etanol',
    'abastecimento.protheus.combustivel.Gasolina': 'Gasolina',
    'abastecimento.protheus.col.data': 'Data',
    'abastecimento.protheus.col.placa': 'Placa',
    'abastecimento.protheus.col.motorista': 'Motorista',
    'abastecimento.protheus.col.posto': 'Posto',
    'abastecimento.protheus.col.combustivel': 'Combustível',
    'abastecimento.protheus.col.litros': 'Litros',
    'abastecimento.protheus.col.valorUnitario': 'Valor unitário',
    'abastecimento.protheus.col.valorTotal': 'Valor total',
    'abastecimento.protheus.col.hodometro': 'Hodômetro',
    'abastecimento.protheus.col.tanque': 'Tanque',
    'abastecimento.protheus.col.bomba': 'Bomba',
    'abastecimento.protheus.col.numero': 'Nº abastecimento',
    'abastecimento.eyebrow': 'Logística',
    'abastecimento.eyebrowCentral': 'Central de Informações',
    'abastecimento.hint': 'Uma linha por solicitação gerada no Maquinário da frente.',
    'abastecimento.empty': 'Nenhuma solicitação no período.',
    'abastecimento.count': '{{count}} solicitações',
    'abastecimento.verImagem': 'Ver a imagem da solicitação',
    'abastecimento.imagemTitulo': 'Imagem da solicitação',
    'abastecimento.excluir': 'Excluir solicitação',
    'abastecimento.excluirTitulo': 'Excluir a solicitação?',
    'abastecimento.excluirMensagem': 'A solicitação de {{operador}} em {{data}} sai do histórico. Esta ação não pode ser desfeita.',
    'abastecimento.excluida': 'Solicitação excluída.',
    'abastecimento.col.data': 'Data',
    'abastecimento.col.dia': 'Dia',
    'abastecimento.col.frente': 'Frente',
    'abastecimento.col.cooperante': 'Cooperante',
    'abastecimento.col.fazenda': 'Fazenda',
    'abastecimento.col.operador': 'Operador',
    'abastecimento.col.maquina': 'Máquina',
    'abastecimento.col.horaMaquina': 'Hora máquina',
    'abastecimento.col.litros': 'Litros',
    'abastecimento.col.placaUtilitario': 'Placa',
    'abastecimento.col.motorista': 'Motorista',
    'abastecimento.col.obs': 'Obs',
    'abastecimento.col.responsavel': 'Responsável',
    'abastecimento.aba.indicadores': 'Indicadores',
    'abastecimento.aba.alertas': 'Relatório de Alertas',
    'abastecimento.protheus.col.base': 'Base',
    'abastecimento.protheus.col.funcao': 'Função',
    'abastecimento.protheus.col.dupla': 'Dupla',
    'abastecimento.filtro.cidade': 'Cidade',
    'abastecimento.filtro.estado': 'Estado',
    'abastecimento.protheus.col.kmVazioPct': '% KM vazio',
    'abastecimento.protheus.col.kmCheioPct': '% KM cheio',
    'abastecimento.protheus.kmPctHint': 'Só Espiga. KM vazio e KM cheio do rastreador entre o abastecimento anterior e este, pela régua do KM vazio de Viagens.',
    'abastecimento.protheus.semDados': 'Sem dados',
    'abastecimento.protheus.foraDoHub': 'FORA DO HUB',
    'abastecimento.funcao.motorista': 'Motorista',
    'abastecimento.funcao.manobra': 'Manobra',
    'abastecimento.funcao.prancheiro': 'Prancheiro',
    'abastecimento.funcao.operador': 'Operador',
    'abastecimento.semBase': 'Sem base',
    'abastecimento.semPosto': 'Sem posto',
    'abastecimento.indicadores.motoristas': 'Média km/L de Motoristas',
    'abastecimento.indicadores.prancheiros': 'Média km/L de Prancheiros',
    'abastecimento.indicadores.operadores': 'Média km/L de Operadores',
    'abastecimento.indicadores.basesEspiga': 'Média km/L por Base de Espiga',
    'abastecimento.indicadores.basesPrancha': 'Média km/L por Base de Prancha',
    'abastecimento.indicadores.postosInternos': 'Litros por posto interno',
    'abastecimento.indicadores.postosExternos': 'Litros por posto externo',
    'abastecimento.indicadores.hint': 'Média consolidada: o total de km dividido pelo total de litros dos mesmos abastecimentos. Os rankings seguem os filtros.',
    'abastecimento.indicadores.vazio': 'Nenhum abastecimento no filtro.',
    'abastecimento.indicadores.detalheMedia': '{{km}} km em {{litros}} L',
    'abastecimento.visual.postos': 'Postos',
    'abastecimento.visual.combustiveis': 'Combustíveis',
    'abastecimento.visual.semPreco': 'Sem preço no período',
    'abastecimento.visual.precoPorLitro': '{{preco}} por litro',
    'abastecimento.visual.valorApoio': '{{count}} abastecimentos, {{litros}} L',
    'abastecimento.visual.utilitario': 'Utilitário',
    'abastecimento.visual.maquinaOperador': 'Máquina e operador',
    'abastecimento.visual.horaMaquina': '{{hora}} h na máquina',
    'abastecimento.indicadores.destaque.motorista': 'Maior média de motorista',
    'abastecimento.indicadores.destaque.base': 'Maior média de base de espiga',
    'abastecimento.indicadores.destaque.interno': 'Posto interno com mais litros',
    'abastecimento.indicadores.destaque.externo': 'Posto externo com mais litros',
    'abastecimento.indicadores.semDestaque': 'Sem dados no filtro',
    'abastecimento.indicadores.combustivel': 'Litros por combustível',
    'abastecimento.indicadores.milLitros': 'mil litros',
    'abastecimento.indicadores.porBase': 'Média km/L por base',
    'abastecimento.indicadores.porBaseAjuda': 'A linha tracejada é a meta de cada categoria: Espiga {{espiga}} km/L e Prancha {{prancha}} km/L. Em vermelho, a média abaixo da faixa do Relatório de Alertas.',
    'abastecimento.indicadores.espiga': 'Espiga',
    'abastecimento.indicadores.prancha': 'Prancha',
    'abastecimento.indicadores.postos': 'Postos internos e externos',
    'abastecimento.indicadores.pctInterno': 'dos abastecimentos em posto interno',
    'abastecimento.indicadores.maiores': 'Maiores médias',
    'abastecimento.indicadores.menores': 'Menores médias',
    'abastecimento.alertas.total': 'Alertas',
    'abastecimento.alertas.totalApoio': 'Média fora da faixa e posto externo',
    'abastecimento.alertas.doTotal': '{{pct}}% do total',
    'abastecimento.alertas.status.pendente': 'Pendente',
    'abastecimento.alertas.status.corrigido': 'Corrigido',
    'abastecimento.alertas.status.justificado': 'Justificado',
    'abastecimento.alertas.tipo.media_abaixo': 'Média abaixo da faixa',
    'abastecimento.alertas.tipo.media_acima': 'Média acima da faixa',
    'abastecimento.alertas.categoria.espiga': 'Espiga',
    'abastecimento.alertas.categoria.prancha': 'Prancha',
    'abastecimento.alertas.col.tipo': 'Alerta',
    'abastecimento.alertas.col.media': 'Média km/L',
    'abastecimento.alertas.col.faixa': 'Meta e faixa',
    'abastecimento.alertas.col.status': 'Status',
    'abastecimento.alertas.meta': 'Meta {{meta}} km/L',
    'abastecimento.alertas.faixaDe': '{{minimo}} a {{maximo}} km/L',
    'abastecimento.alertas.regra': 'Meta {{meta}} km/L. Alerta abaixo de {{minimo}} ou acima de {{maximo}} km/L; o limite exato é aceito.',
    'abastecimento.alertas.count': '{{count}} alertas',
    'abastecimento.alertas.hint': 'Média da Espiga e da Prancha, e posto externo da máquina e das cidades de filial. O que for corrigido no Protheus vira Corrigido na próxima sincronização.',
    'abastecimento.alertas.vazio': 'Nenhum alerta no filtro.',
    'abastecimento.alertas.filtroStatus': 'Status do alerta',
    'abastecimento.alertas.justificar': 'Justificar',
    'abastecimento.alertas.editarJustificativa': 'Editar justificativa',
    'abastecimento.alertas.justificarTitulo': 'Justificar a média',
    'abastecimento.alertas.justificado': 'Alerta justificado.',
    'abastecimento.alertas.ajudaJustificativa': 'Diga por que a média fica como está. O registro guarda quem justificou e quando.',
    'abastecimento.alertas.identificacao': 'Placa {{placa}} em {{data}}',
    'abastecimento.alertas.quemQuando': '{{quem}} em {{quando}}',
    'abastecimento.alertas.alguem': 'Alguém',
    'abastecimento.alertas.antes': 'Antes',
    'abastecimento.alertas.corrigidoPelaMedia': 'Média de volta à faixa em {{quando}}',
    'abastecimento.alertas.corrigidoRemovido': 'Saiu do Protheus em {{quando}}',
    'abastecimento.alertas.foraDoProtheus': 'Abastecimento fora do Protheus',
    'abastecimento.alertas.tipo.externo_maquina': 'Máquina em posto externo',
    'abastecimento.alertas.tipo.externo_filial': 'Posto externo na filial',
    'abastecimento.alertas.categoria.maquina': 'Máquina',
    'abastecimento.alertas.categoria.utilitario': 'Frota leve',
    'abastecimento.alertas.semCadastro': 'Sem cadastro de frota',
    'abastecimento.alertas.regraMaquina': 'Máquina abastecida em posto externo. Vale para qualquer cidade e qualquer combustível.',
    'abastecimento.alertas.regraFilial': 'Posto externo em {{cidade}} com {{combustivel}}, produto que a filial da cidade vende.',
    'abastecimento.alertas.filtroTipo': 'Tipo do alerta',
    'abastecimento.alertas.justificarPostoTitulo': 'Justificar o posto externo',
    'abastecimento.alertas.ajudaJustificativaPosto': 'Diga por que o abastecimento foi feito no posto externo. O registro guarda quem justificou e quando.',
    'abastecimento.alertas.corrigidoPeloCadastro': 'Posto, produto ou veículo corrigido em {{quando}}',
  },
  en: {
    'abastecimento.title': 'Fuel',
    'abastecimento.aba.abastecimentos': 'Refuelings',
    'abastecimento.aba.solicitacoes': 'Fuel requests',
    'abastecimento.protheus.hint': 'Recorded in Protheus, from 09/01/2026 on.',
    'abastecimento.protheus.empty': 'No refueling in the period.',
    'abastecimento.protheus.count': '{{count}} refuelings',
    'abastecimento.protheus.litros': '{{litros}} litres',
    'abastecimento.protheus.matricula': 'Employee ID {{matricula}}',
    'abastecimento.protheus.col.modalidade': 'Modality',
    'abastecimento.protheus.col.kmRodado': 'Distance traveled',
    'abastecimento.protheus.col.kmL': 'Km/L',
    'abastecimento.protheus.tipo': 'Refueling type',
    'abastecimento.protheus.interno': 'Internal',
    'abastecimento.protheus.externo': 'External',
    'abastecimento.protheus.internoHint': 'Transgrãos and Valorem stations',
    'abastecimento.protheus.externoHint': 'Other stations',
    'abastecimento.protheus.mediaGeral': 'Overall average',
    'abastecimento.protheus.kmHint': 'Sum of valid intervals, excluding Arla',
    'abastecimento.protheus.mediaHint': 'Km divided by litres, excluding Arla',
    'abastecimento.protheus.precoMedio': 'Average price per litre',
    'abastecimento.protheus.combustivel.S10': 'S10',
    'abastecimento.protheus.combustivel.S500': 'S500',
    'abastecimento.protheus.combustivel.Arla': 'Arla',
    'abastecimento.protheus.combustivel.Etanol': 'Ethanol',
    'abastecimento.protheus.combustivel.Gasolina': 'Gasoline',
    'abastecimento.protheus.col.data': 'Date',
    'abastecimento.protheus.col.placa': 'Plate',
    'abastecimento.protheus.col.motorista': 'Driver',
    'abastecimento.protheus.col.posto': 'Station',
    'abastecimento.protheus.col.combustivel': 'Fuel',
    'abastecimento.protheus.col.litros': 'Litres',
    'abastecimento.protheus.col.valorUnitario': 'Unit price',
    'abastecimento.protheus.col.valorTotal': 'Total',
    'abastecimento.protheus.col.hodometro': 'Odometer',
    'abastecimento.protheus.col.tanque': 'Tank',
    'abastecimento.protheus.col.bomba': 'Pump',
    'abastecimento.protheus.col.numero': 'Refueling no.',
    'abastecimento.eyebrow': 'Logistics',
    'abastecimento.eyebrowCentral': 'Information Center',
    'abastecimento.hint': 'One row per request generated in the front machinery block.',
    'abastecimento.empty': 'No requests in the period.',
    'abastecimento.count': '{{count}} requests',
    'abastecimento.verImagem': 'See the request image',
    'abastecimento.imagemTitulo': 'Request image',
    'abastecimento.excluir': 'Delete request',
    'abastecimento.excluirTitulo': 'Delete the request?',
    'abastecimento.excluirMensagem': 'The request of {{operador}} on {{data}} leaves the history. This cannot be undone.',
    'abastecimento.excluida': 'Request deleted.',
    'abastecimento.col.data': 'Date',
    'abastecimento.col.dia': 'Day',
    'abastecimento.col.frente': 'Front',
    'abastecimento.col.cooperante': 'Cooperant',
    'abastecimento.col.fazenda': 'Farm',
    'abastecimento.col.operador': 'Operator',
    'abastecimento.col.maquina': 'Machine',
    'abastecimento.col.horaMaquina': 'Machine hours',
    'abastecimento.col.litros': 'Litres',
    'abastecimento.col.placaUtilitario': 'Plate',
    'abastecimento.col.motorista': 'Driver',
    'abastecimento.col.obs': 'Notes',
    'abastecimento.col.responsavel': 'Entered by',
    'abastecimento.aba.indicadores': 'Indicators',
    'abastecimento.aba.alertas': 'Alerts report',
    'abastecimento.protheus.col.base': 'Base',
    'abastecimento.protheus.col.funcao': 'Role',
    'abastecimento.protheus.col.dupla': 'Pair',
    'abastecimento.filtro.cidade': 'City',
    'abastecimento.filtro.estado': 'State',
    'abastecimento.protheus.col.kmVazioPct': '% empty km',
    'abastecimento.protheus.col.kmCheioPct': '% loaded km',
    'abastecimento.protheus.kmPctHint': 'Espiga only. Empty and loaded km from the tracker between the previous refueling and this one, by the empty km rule of Trips.',
    'abastecimento.protheus.semDados': 'No data',
    'abastecimento.protheus.foraDoHub': 'OUTSIDE THE HUB',
    'abastecimento.funcao.motorista': 'Driver',
    'abastecimento.funcao.manobra': 'Yard driver',
    'abastecimento.funcao.prancheiro': 'Lowboy driver',
    'abastecimento.funcao.operador': 'Operator',
    'abastecimento.semBase': 'No base',
    'abastecimento.semPosto': 'No station',
    'abastecimento.indicadores.motoristas': 'Drivers average km/L',
    'abastecimento.indicadores.prancheiros': 'Lowboy drivers average km/L',
    'abastecimento.indicadores.operadores': 'Operators average km/L',
    'abastecimento.indicadores.basesEspiga': 'Average km/L by Espiga base',
    'abastecimento.indicadores.basesPrancha': 'Average km/L by lowboy base',
    'abastecimento.indicadores.postosInternos': 'Litres by internal station',
    'abastecimento.indicadores.postosExternos': 'Litres by external station',
    'abastecimento.indicadores.hint': 'Consolidated average: total km divided by total litres of the same refuelings. The rankings follow the filters.',
    'abastecimento.indicadores.vazio': 'No refueling in the filter.',
    'abastecimento.indicadores.detalheMedia': '{{km}} km in {{litros}} L',
    'abastecimento.visual.postos': 'Stations',
    'abastecimento.visual.combustiveis': 'Fuels',
    'abastecimento.visual.semPreco': 'No price in the period',
    'abastecimento.visual.precoPorLitro': '{{preco}} per litre',
    'abastecimento.visual.valorApoio': '{{count}} refuelings, {{litros}} L',
    'abastecimento.visual.utilitario': 'Utility vehicle',
    'abastecimento.visual.maquinaOperador': 'Machine and operator',
    'abastecimento.visual.horaMaquina': '{{hora}} machine hours',
    'abastecimento.indicadores.destaque.motorista': 'Best driver average',
    'abastecimento.indicadores.destaque.base': 'Best corn truck base average',
    'abastecimento.indicadores.destaque.interno': 'Internal station with most litres',
    'abastecimento.indicadores.destaque.externo': 'External station with most litres',
    'abastecimento.indicadores.semDestaque': 'No data in the filter',
    'abastecimento.indicadores.combustivel': 'Litres by fuel',
    'abastecimento.indicadores.milLitros': 'thousand litres',
    'abastecimento.indicadores.porBase': 'Average km/L by base',
    'abastecimento.indicadores.porBaseAjuda': 'The dashed line is each category target: corn truck {{espiga}} km/L and flatbed {{prancha}} km/L. In red, the average below the Alerts Report range.',
    'abastecimento.indicadores.espiga': 'Corn truck',
    'abastecimento.indicadores.prancha': 'Flatbed',
    'abastecimento.indicadores.postos': 'Internal and external stations',
    'abastecimento.indicadores.pctInterno': 'of refuelings at internal stations',
    'abastecimento.indicadores.maiores': 'Highest averages',
    'abastecimento.indicadores.menores': 'Lowest averages',
    'abastecimento.alertas.total': 'Alerts',
    'abastecimento.alertas.totalApoio': 'Average out of range and external station',
    'abastecimento.alertas.doTotal': '{{pct}}% of total',
    'abastecimento.alertas.status.pendente': 'Pending',
    'abastecimento.alertas.status.corrigido': 'Fixed',
    'abastecimento.alertas.status.justificado': 'Justified',
    'abastecimento.alertas.tipo.media_abaixo': 'Average below range',
    'abastecimento.alertas.tipo.media_acima': 'Average above range',
    'abastecimento.alertas.categoria.espiga': 'Espiga',
    'abastecimento.alertas.categoria.prancha': 'Lowboy',
    'abastecimento.alertas.col.tipo': 'Alert',
    'abastecimento.alertas.col.media': 'Average km/L',
    'abastecimento.alertas.col.faixa': 'Target and range',
    'abastecimento.alertas.col.status': 'Status',
    'abastecimento.alertas.meta': 'Target {{meta}} km/L',
    'abastecimento.alertas.faixaDe': '{{minimo}} to {{maximo}} km/L',
    'abastecimento.alertas.regra': 'Target {{meta}} km/L. Alert below {{minimo}} or above {{maximo}} km/L; the exact limit is accepted.',
    'abastecimento.alertas.count': '{{count}} alerts',
    'abastecimento.alertas.hint': 'Espiga and lowboy average, and outside stations for machines and branch cities. What is fixed in Protheus turns Fixed at the next sync.',
    'abastecimento.alertas.vazio': 'No alert in the filter.',
    'abastecimento.alertas.filtroStatus': 'Alert status',
    'abastecimento.alertas.justificar': 'Justify',
    'abastecimento.alertas.editarJustificativa': 'Edit justification',
    'abastecimento.alertas.justificarTitulo': 'Justify the average',
    'abastecimento.alertas.justificado': 'Alert justified.',
    'abastecimento.alertas.ajudaJustificativa': 'Say why the average stays as it is. The record keeps who justified it and when.',
    'abastecimento.alertas.identificacao': 'Plate {{placa}} on {{data}}',
    'abastecimento.alertas.quemQuando': '{{quem}} on {{quando}}',
    'abastecimento.alertas.alguem': 'Someone',
    'abastecimento.alertas.antes': 'Before',
    'abastecimento.alertas.corrigidoPelaMedia': 'Average back in range on {{quando}}',
    'abastecimento.alertas.corrigidoRemovido': 'Left Protheus on {{quando}}',
    'abastecimento.alertas.foraDoProtheus': 'Refueling no longer in Protheus',
    'abastecimento.alertas.tipo.externo_maquina': 'Machine at an outside station',
    'abastecimento.alertas.tipo.externo_filial': 'Outside station in a branch city',
    'abastecimento.alertas.categoria.maquina': 'Machine',
    'abastecimento.alertas.categoria.utilitario': 'Light fleet',
    'abastecimento.alertas.semCadastro': 'Not in the fleet registry',
    'abastecimento.alertas.regraMaquina': 'Machine refueled at an outside station. Applies to any city and any fuel.',
    'abastecimento.alertas.regraFilial': 'Outside station in {{cidade}} with {{combustivel}}, a product the branch in that city sells.',
    'abastecimento.alertas.filtroTipo': 'Alert type',
    'abastecimento.alertas.justificarPostoTitulo': 'Justify the outside station',
    'abastecimento.alertas.ajudaJustificativaPosto': 'Say why the refueling was done at an outside station. The record keeps who justified it and when.',
    'abastecimento.alertas.corrigidoPeloCadastro': 'Station, product or vehicle fixed on {{quando}}',
  },
  es: {
    'abastecimento.title': 'Abastecimientos',
    'abastecimento.aba.abastecimentos': 'Abastecimientos',
    'abastecimento.aba.solicitacoes': 'Solicitud de abastecimiento',
    'abastecimento.protheus.hint': 'Registrados en Protheus, desde el 01/09/2026.',
    'abastecimento.protheus.empty': 'Ningún abastecimiento en el período.',
    'abastecimento.protheus.count': '{{count}} abastecimientos',
    'abastecimento.protheus.litros': '{{litros}} litros',
    'abastecimento.protheus.matricula': 'Matrícula {{matricula}}',
    'abastecimento.protheus.col.modalidade': 'Modalidad',
    'abastecimento.protheus.col.kmRodado': 'Km recorrido',
    'abastecimento.protheus.col.kmL': 'Km/L',
    'abastecimento.protheus.tipo': 'Tipo de abastecimiento',
    'abastecimento.protheus.interno': 'Interno',
    'abastecimento.protheus.externo': 'Externo',
    'abastecimento.protheus.internoHint': 'Estaciones Transgrãos y Valorem',
    'abastecimento.protheus.externoHint': 'Demás estaciones',
    'abastecimento.protheus.mediaGeral': 'Promedio general',
    'abastecimento.protheus.kmHint': 'Suma de intervalos válidos, sin Arla',
    'abastecimento.protheus.mediaHint': 'Km dividido por litros, sin Arla',
    'abastecimento.protheus.precoMedio': 'Precio medio por litro',
    'abastecimento.protheus.combustivel.S10': 'S10',
    'abastecimento.protheus.combustivel.S500': 'S500',
    'abastecimento.protheus.combustivel.Arla': 'Arla',
    'abastecimento.protheus.combustivel.Etanol': 'Etanol',
    'abastecimento.protheus.combustivel.Gasolina': 'Gasolina',
    'abastecimento.protheus.col.data': 'Fecha',
    'abastecimento.protheus.col.placa': 'Placa',
    'abastecimento.protheus.col.motorista': 'Conductor',
    'abastecimento.protheus.col.posto': 'Estación',
    'abastecimento.protheus.col.combustivel': 'Combustible',
    'abastecimento.protheus.col.litros': 'Litros',
    'abastecimento.protheus.col.valorUnitario': 'Valor unitario',
    'abastecimento.protheus.col.valorTotal': 'Valor total',
    'abastecimento.protheus.col.hodometro': 'Odómetro',
    'abastecimento.protheus.col.tanque': 'Tanque',
    'abastecimento.protheus.col.bomba': 'Bomba',
    'abastecimento.protheus.col.numero': 'Nº abastecimiento',
    'abastecimento.eyebrow': 'Logística',
    'abastecimento.eyebrowCentral': 'Central de Información',
    'abastecimento.hint': 'Una línea por solicitud generada en la maquinaria del frente.',
    'abastecimento.empty': 'Ninguna solicitud en el período.',
    'abastecimento.count': '{{count}} solicitudes',
    'abastecimento.verImagem': 'Ver la imagen de la solicitud',
    'abastecimento.imagemTitulo': 'Imagen de la solicitud',
    'abastecimento.excluir': 'Eliminar solicitud',
    'abastecimento.excluirTitulo': '¿Eliminar la solicitud?',
    'abastecimento.excluirMensagem': 'La solicitud de {{operador}} del {{data}} sale del historial. Esta acción no se puede deshacer.',
    'abastecimento.excluida': 'Solicitud eliminada.',
    'abastecimento.col.data': 'Fecha',
    'abastecimento.col.dia': 'Día',
    'abastecimento.col.frente': 'Frente',
    'abastecimento.col.cooperante': 'Cooperante',
    'abastecimento.col.fazenda': 'Hacienda',
    'abastecimento.col.operador': 'Operador',
    'abastecimento.col.maquina': 'Máquina',
    'abastecimento.col.horaMaquina': 'Hora máquina',
    'abastecimento.col.litros': 'Litros',
    'abastecimento.col.placaUtilitario': 'Placa',
    'abastecimento.col.motorista': 'Conductor',
    'abastecimento.col.obs': 'Obs',
    'abastecimento.col.responsavel': 'Responsable',
    'abastecimento.aba.indicadores': 'Indicadores',
    'abastecimento.aba.alertas': 'Informe de alertas',
    'abastecimento.protheus.col.base': 'Base',
    'abastecimento.protheus.col.funcao': 'Función',
    'abastecimento.protheus.col.dupla': 'Pareja',
    'abastecimento.filtro.cidade': 'Ciudad',
    'abastecimento.filtro.estado': 'Estado',
    'abastecimento.protheus.col.kmVazioPct': '% km vacío',
    'abastecimento.protheus.col.kmCheioPct': '% km cargado',
    'abastecimento.protheus.kmPctHint': 'Solo Espiga. Km vacío y km cargado del rastreador entre el abastecimiento anterior y este, por la regla del km vacío de Viajes.',
    'abastecimento.protheus.semDados': 'Sin datos',
    'abastecimento.protheus.foraDoHub': 'FUERA DEL HUB',
    'abastecimento.funcao.motorista': 'Conductor',
    'abastecimento.funcao.manobra': 'Maniobra',
    'abastecimento.funcao.prancheiro': 'Conductor de cama baja',
    'abastecimento.funcao.operador': 'Operador',
    'abastecimento.semBase': 'Sin base',
    'abastecimento.semPosto': 'Sin estación',
    'abastecimento.indicadores.motoristas': 'Promedio km/L de conductores',
    'abastecimento.indicadores.prancheiros': 'Promedio km/L de conductores de cama baja',
    'abastecimento.indicadores.operadores': 'Promedio km/L de operadores',
    'abastecimento.indicadores.basesEspiga': 'Promedio km/L por base de Espiga',
    'abastecimento.indicadores.basesPrancha': 'Promedio km/L por base de cama baja',
    'abastecimento.indicadores.postosInternos': 'Litros por estación interna',
    'abastecimento.indicadores.postosExternos': 'Litros por estación externa',
    'abastecimento.indicadores.hint': 'Promedio consolidado: el total de km dividido por el total de litros de los mismos abastecimientos. Los rankings siguen los filtros.',
    'abastecimento.indicadores.vazio': 'Ningún abastecimiento en el filtro.',
    'abastecimento.indicadores.detalheMedia': '{{km}} km en {{litros}} L',
    'abastecimento.visual.postos': 'Puestos',
    'abastecimento.visual.combustiveis': 'Combustibles',
    'abastecimento.visual.semPreco': 'Sin precio en el período',
    'abastecimento.visual.precoPorLitro': '{{preco}} por litro',
    'abastecimento.visual.valorApoio': '{{count}} abastecimientos, {{litros}} L',
    'abastecimento.visual.utilitario': 'Utilitario',
    'abastecimento.visual.maquinaOperador': 'Máquina y operador',
    'abastecimento.visual.horaMaquina': '{{hora}} h de máquina',
    'abastecimento.indicadores.destaque.motorista': 'Mayor promedio de conductor',
    'abastecimento.indicadores.destaque.base': 'Mayor promedio de base de espiga',
    'abastecimento.indicadores.destaque.interno': 'Puesto interno con más litros',
    'abastecimento.indicadores.destaque.externo': 'Puesto externo con más litros',
    'abastecimento.indicadores.semDestaque': 'Sin datos en el filtro',
    'abastecimento.indicadores.combustivel': 'Litros por combustible',
    'abastecimento.indicadores.milLitros': 'mil litros',
    'abastecimento.indicadores.porBase': 'Promedio km/L por base',
    'abastecimento.indicadores.porBaseAjuda': 'La línea discontinua es la meta de cada categoría: Espiga {{espiga}} km/L y Plancha {{prancha}} km/L. En rojo, el promedio por debajo del rango del Informe de Alertas.',
    'abastecimento.indicadores.espiga': 'Espiga',
    'abastecimento.indicadores.prancha': 'Plancha',
    'abastecimento.indicadores.postos': 'Puestos internos y externos',
    'abastecimento.indicadores.pctInterno': 'de los abastecimientos en puesto interno',
    'abastecimento.indicadores.maiores': 'Mayores promedios',
    'abastecimento.indicadores.menores': 'Menores promedios',
    'abastecimento.alertas.total': 'Alertas',
    'abastecimento.alertas.totalApoio': 'Promedio fuera del rango y puesto externo',
    'abastecimento.alertas.doTotal': '{{pct}}% del total',
    'abastecimento.alertas.status.pendente': 'Pendiente',
    'abastecimento.alertas.status.corrigido': 'Corregido',
    'abastecimento.alertas.status.justificado': 'Justificado',
    'abastecimento.alertas.tipo.media_abaixo': 'Promedio debajo del rango',
    'abastecimento.alertas.tipo.media_acima': 'Promedio encima del rango',
    'abastecimento.alertas.categoria.espiga': 'Espiga',
    'abastecimento.alertas.categoria.prancha': 'Cama baja',
    'abastecimento.alertas.col.tipo': 'Alerta',
    'abastecimento.alertas.col.media': 'Promedio km/L',
    'abastecimento.alertas.col.faixa': 'Meta y rango',
    'abastecimento.alertas.col.status': 'Estado',
    'abastecimento.alertas.meta': 'Meta {{meta}} km/L',
    'abastecimento.alertas.faixaDe': '{{minimo}} a {{maximo}} km/L',
    'abastecimento.alertas.regra': 'Meta {{meta}} km/L. Alerta debajo de {{minimo}} o encima de {{maximo}} km/L; el límite exacto se acepta.',
    'abastecimento.alertas.count': '{{count}} alertas',
    'abastecimento.alertas.hint': 'Promedio de espiga y cama baja, y puesto externo de las máquinas y de las ciudades con filial. Lo corregido en Protheus pasa a Corregido en la próxima sincronización.',
    'abastecimento.alertas.vazio': 'Ninguna alerta en el filtro.',
    'abastecimento.alertas.filtroStatus': 'Estado de la alerta',
    'abastecimento.alertas.justificar': 'Justificar',
    'abastecimento.alertas.editarJustificativa': 'Editar justificación',
    'abastecimento.alertas.justificarTitulo': 'Justificar el promedio',
    'abastecimento.alertas.justificado': 'Alerta justificada.',
    'abastecimento.alertas.ajudaJustificativa': 'Diga por qué el promedio queda como está. El registro guarda quién justificó y cuándo.',
    'abastecimento.alertas.identificacao': 'Placa {{placa}} el {{data}}',
    'abastecimento.alertas.quemQuando': '{{quem}} el {{quando}}',
    'abastecimento.alertas.alguem': 'Alguien',
    'abastecimento.alertas.antes': 'Antes',
    'abastecimento.alertas.corrigidoPelaMedia': 'Promedio de vuelta al rango el {{quando}}',
    'abastecimento.alertas.corrigidoRemovido': 'Salió de Protheus el {{quando}}',
    'abastecimento.alertas.foraDoProtheus': 'Abastecimiento fuera de Protheus',
    'abastecimento.alertas.tipo.externo_maquina': 'Máquina en puesto externo',
    'abastecimento.alertas.tipo.externo_filial': 'Puesto externo en la filial',
    'abastecimento.alertas.categoria.maquina': 'Máquina',
    'abastecimento.alertas.categoria.utilitario': 'Flota liviana',
    'abastecimento.alertas.semCadastro': 'Sin registro de flota',
    'abastecimento.alertas.regraMaquina': 'Máquina abastecida en puesto externo. Vale para cualquier ciudad y cualquier combustible.',
    'abastecimento.alertas.regraFilial': 'Puesto externo en {{cidade}} con {{combustivel}}, producto que vende la filial de la ciudad.',
    'abastecimento.alertas.filtroTipo': 'Tipo de alerta',
    'abastecimento.alertas.justificarPostoTitulo': 'Justificar el puesto externo',
    'abastecimento.alertas.ajudaJustificativaPosto': 'Diga por qué el abastecimiento se hizo en el puesto externo. El registro guarda quién justificó y cuándo.',
    'abastecimento.alertas.corrigidoPeloCadastro': 'Puesto, producto o vehículo corregido el {{quando}}',
  },
}
